const fromDtoToNcobEgiftSettings = (item) =>
  !item
    ? item
    : {
        canTakeVoucherPayments: item.can_take_voucher_payments,
        stripeAccountStatus: item.stripe_account_status,
      };

export default fromDtoToNcobEgiftSettings;
